/*
 * $Id:: ActionsButton.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { t } from '../../../../../providers';

const ActionsButton = ({ account, edit, setStatus }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const editAccount = (event) => {
        event.preventDefault();
        edit(account);
        handleClose();
    };

    const setAccountStatus = (event) => {
        event.preventDefault();
        setStatus(account);
        handleClose();
    };

    return (
        <React.Fragment>
            <IconButton aria-label="more" aria-controls="long-menu" aria-haspopup="true" onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem onClick={editAccount}>{t('edit')}</MenuItem>
                <MenuItem onClick={setAccountStatus}>{t(account.status === 'Active' ? 'deactivate' : 'activate')}</MenuItem>
            </Menu>
        </React.Fragment>
    );
};

export default ActionsButton;
